
import { Vue } from "vue-class-component";

export default class Option extends Vue {}
